module.exports = function() {
  return new Worker(__webpack_public_path__ + "e52962ee602b374e3254.worker.js");
};